// "He/She" in each template is swapped for the student's actual pronoun at
// render time - see `getRemarkWithPronoun` in `Helper/remarks.helper.ts`.
export const PREDEFINED_REMARKS: string[] = [
  "Excellent performance.",
  "Very good performance.",
  "Good performance.",
  "Keep up the good work.",
  "Keep it up.",
  "He/She can do even better.",
  "He/She is capable of doing better.",
  "He/She has the potential to improve.",
  "He/She needs to be more focused.",
  "He/She needs to pay more attention to studies.",
  "He/She needs further guidance.",
  "He/She needs more guidance at home.",
  "He/She should attend classes regularly.",
  "He/She should participate more actively in class.",
  "He/She needs to improve his/her handwriting.",
  "He/She has improved his/her handwriting.",
  "He/She needs to complete homework regularly.",
  "He/She should be more disciplined.",
  "He/She should be more responsible.",
  "He/She needs to be more confident.",
  "He/She needs to improve concentration.",
  "He/She should manage time more effectively.",
  "He/She needs to participate more in classroom activities.",
  "He/She shows steady progress.",
  "He/She has shown improvement.",
  "He/She has the ability to achieve more.",
  "He/She works well in class.",
  "He/She should be more consistent in studies.",
  "He/She needs to reduce carelessness.",
  "He/She should practice regularly.",
  "He/She needs encouragement to perform better.",
  "He/She maintains a positive attitude.",
  "He/She should be more punctual.",
  "He/She should take greater interest in studies.",
  "He/She can achieve better results with more effort.",
  "He/She is a sincere student.",
  "He/She is a hardworking student.",
  "He/She should revise lessons regularly.",
  "He/She needs regular practice.",
  "He/She shows good learning potential.",
  "Excellent! Keep it up.",
  "He/She needs to work harder to do better than this.",
  "Well done! Keep it up.",
  "Slight improvement, but still needs a lot of hard work.",
];
